//import {recaptchaToken} from "../store/utils";
const axios = require('axios')
//const adapterURL = "http://192.168.86.25:3006";
const adapterURL = "https://web-api.mallocdata.com";
import AuthUser from './../auth';

export default {
    fetchPage: async (pageID) => {
        let response = await axios.get(`${adapterURL}/pages/${pageID}`, {
            responseType: 'json',
            headers: {'jwt': AuthUser.getJWT()},
        });

        return response.data;
    },

    submitSearch: async (unit, address, email) => {
        //let token = await recaptchaToken('searchSubmit');
        let response = await axios.post(`${adapterURL}/search`, {
            unit: unit,
            address: address,
            email: email,
            jwt: AuthUser.getJWT(),
            //googleToken: token
        }, {
            responseType: 'json',
        });

        return response.data;
    },

    autoComplete: async (address) => {
        //let token = await recaptchaToken('searchSubmit');
        let response = await axios.get(`${adapterURL}/search/address-auto-complete?input=${encodeURIComponent(address)}`, {
            responseType: 'json',
        });

        return response.data;
    },

    verifyEmailUser: async (code) => {
        let response = await axios.post(`${adapterURL}/users/email-verify`, {}, {
            responseType: 'json',
            headers: {'jwt': code },
        });

        return response.data;
    },

    login: async (email, password) => {
        //let token = await recaptchaToken('login');
        let response = await axios.post(`${adapterURL}/users/login`, {
            email: email,
            password: password,
            //googleToken: token,
        }, {
            responseType: 'json',
        });

        return response.data;
    },

    fbLogin: async (fbID, fbToken) => {
        let response = await axios.post(`${adapterURL}/users/fb-login`, {
            fbUserID: fbID,
            authToken: fbToken,
        }, {
            responseType: 'json',
        });

        return response.data;
    },

    signUp: async (name, email, password) => {
        //let token = await recaptchaToken('signUp');
        let response = await axios.post(`${adapterURL}/users/sign-up`, {
            name: name,
            email: email,
            password: password,
           // googleToken: token,
        }, {
            responseType: 'json',
        });

        return response.data;
    },

    getUserNotificationSettingsToken: async (jwt) => {
        let response = await axios.get(`${adapterURL}/users/notification-settings-token`, {
            responseType: 'json',
            headers: {'jwt': jwt },
        });

        return response.data;
    },

    getUserNotificationSettings: async () => {
        let response = await axios.get(`${adapterURL}/users/notification-settings`, {
            responseType: 'json',
            headers: {'jwt': AuthUser.getJWT()},
        });

        return response.data;
    },

    updateUserNotification: async (key, value) => {
        let data = {};
        data[key] = value;
        let response = await axios.put(`${adapterURL}/users/notification-settings`, data, {
            responseType: 'json',
            headers: {'jwt': AuthUser.getJWT()},
        });

        return response.data;
    },

    updateUserNotificationByToken: async (key, value, token) => {
        let data = {};
        data[key] = value;
        let response = await axios.put(`${adapterURL}/users/notification-settings-token`, data, {
            responseType: 'json',
            headers: {'jwt': token},
        });

        return response.data;
    },

    forgotPassword: async (email) => {
        //let token = await recaptchaToken('forgotPassword');
        let response = await axios.post(`${adapterURL}/users/forgot-password`, {
            email: email,
            //googleToken: token,
        }, {
            responseType: 'json',
        });

        return response.data;
    },

    resetPassword: async (jwt, password) => {
        //let googleToken = await recaptchaToken('forgotPassword');
        let response = await axios.post(`${adapterURL}/users/password-reset`, {
            password: password,
           // googleToken: googleToken,
        }, {
            responseType: 'json',
            headers: {'jwt': jwt},
        });

        return response.data;
    },

    getUserRequests: async () => {
        let response = await axios.get(`${adapterURL}/users/requests`, {
            headers: {'jwt': AuthUser.getJWT()},
            responseType: 'json',
        });

        return response.data;
    },

    deleteUserRequests: async (requestID) => {
        let response = await axios.delete(`${adapterURL}/users/requests/${requestID}`, {
            headers: {'jwt': AuthUser.getJWT()},
            responseType: 'json',
        });

        return response.data;
    },

    getPropertyPriceHistory: async (unifiedAddressID) => {
        let response = await axios.get(`${adapterURL}/users/get-property-price-history/${unifiedAddressID}`, {
            headers: {'jwt': AuthUser.getJWT()},
            responseType: 'json',
        });

        return response.data;
    },

    subToggle: async (requestID, subscribe = null) => {
        let response = await axios.post(`${adapterURL}/users/sub-toggle/${requestID}`, {
            subscribe: subscribe
        }, {
            headers: {'jwt': AuthUser.getJWT()},
            responseType: 'json',
        });

        return response.data;
    },

    saveRequest: async (unifiedAddressID) => {
        let response = await axios.post(`${adapterURL}/users/requests`, {
            unifiedAddressID: unifiedAddressID
        }, {
            headers: {'jwt': AuthUser.getJWT()},
            responseType: 'json',
        });

        return response.data;
    },

    sendFeedback: async (email, message) => {
       // let token = await recaptchaToken('feedback');
        let response = await axios.post(`${adapterURL}/feedback`, {
            email: email,
            message: message,
           // googleToken: token
        }, {
            responseType: 'json',
        });

        return response.data;
    },

    recordPrice: async (unifiedAddressID, price, ts) => {
        let response = await axios.post(`${adapterURL}/users/record-price`, {
            unifiedAddressID: unifiedAddressID,
            price: price,
            ts: ts,
        }, {
            headers: {'jwt': AuthUser.getJWT()},
            responseType: 'json',
        });

        return response.data;
    }
}
